import { render, staticRenderFns } from "./fieldListRadios.vue?vue&type=template&id=161edb08&"
import script from "./fieldListRadios.vue?vue&type=script&lang=js&"
export * from "./fieldListRadios.vue?vue&type=script&lang=js&"
import style0 from "./fieldListRadios.vue?vue&type=style&index=0&id=161edb08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports